import React from "react";

const LineProgressBar = ({ indexProgress }) => {
  var width = 50 * indexProgress;
  // const styleCss = `background: linear-gradient(90deg,#008964 0%,#008964 ${width}%,#E5E4E4 ${width}%,#E5E4E4 100%)`;
const styleCss = {
    background: `linear-gradient(90deg,#008964 0%,#008964 ${width}%,#E5E4E4 ${width}%,#E5E4E4 100%)`
}

  

  return (
    <div className="status-bar" style = {styleCss} >       
    </div>
  );
};

export default LineProgressBar;
